import PropTypes from 'prop-types';
export const imageType = PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
});

export const imageArrayType = PropTypes.arrayOf(imageType);